<template>
    <div class="row">
        <div class="col-md-6">
            <h4 style="margin-top: 0px">{{$t("cierreDeCaja")}} - {{cierre.nameTpv}}</h4>
            <p><strong>Nº: {{cierre.idCode}}</strong></p>
            <p><strong>{{$t("operario")}}:</strong> {{cierre.nameWorker}}</p>
            <p><strong>{{$t("apertura")}}:</strong> {{cierre.initDate | parseDateMin}}</p>
            <p><strong>{{$t("cierre")}}:</strong> {{cierre.endDate | parseDateMin}}</p>
            <p><strong>{{$t("primerTicket")}}:</strong> Nº {{cierre.firstTicket}}</p>
            <p><strong>{{$t("ultimoTicket")}}:</strong> Nº {{cierre.lastTicket}}</p>
            <p><strong>{{$t("numeroTickets")}}:</strong> {{cierre.numeroTickets}}</p>

            <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>

            <h5><strong>{{$t("totalVenta")}}: {{cierre.money + cierre.cards + cierre.checks | currency}}</strong></h5>

            <p><strong>{{$t("baseImponible")}}:</strong> {{cierre.baseImponible | currency}}</p>
            <p><strong>{{$t("impuesto")}}:</strong> {{cierre.impuesto | currency}}</p>

            <p><strong>{{$t("efectivo")}}:</strong> {{cierre.money | currency}}</p>
            <p><strong>{{$t("tarjetas")}}:</strong> {{cierre.cards | currency}}</p>
            <p><strong>{{$t("cheques")}}:</strong> {{cierre.checks | currency}}</p>
            <p><strong>{{$t("cambio")}}:</strong> {{cierre.cashChange | currency}}</p>
            <p><strong>{{$t('propina')}}:</strong> {{cierre.propinasAmount | currency}}</p>
            <p><strong>{{$t("gastos")}}:</strong> {{cierre.cashExpenses | currency}}</p>

            <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>

            <p><strong>{{$t("totalTeorico")}}:</strong> {{cierre.money + cierre.cards + cierre.checks + cierre.cashChange-(cierre.cashExpenses)|
                currency}}</p>
            <p><strong>{{$t("totalEnArqueo")}}:  </strong>{{cierre.countAmount| currency}}</p>

            <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>

            <h5><strong>{{$t("descuadre")}}:  <template v-if="cierre.countAmount>0">{{Math.round((cierre.cashExpenses +cierre.countAmount) - (cierre.money + cierre.cards + cierre.checks  + cierre.cashChange)) | currency}}</template><template v-else>{{0 | currency}}</template></strong></h5>

            <p><strong>{{$t("totalEnArqueo")}}:</strong> {{cierre.countAmount | currency}}</p>
            <p><strong>{{$t("cambioSigDia")}}:</strong> {{cierre.changeNextDay | currency}}</p>

            <p style='border-top:1px dashed black; height:2px'>&nbsp;</p>

            <h5><strong>{{$t("totalRecaudado")}}: {{cierre.countAmount - cierre.changeNextDay| currency}}</strong></h5>

        </div>

        <div class="col-md-6">
            <h4 v-if="cierre.observaciones">
                <strong><i style="color: #0976b4"
                           class="fa fa-info-circle"></i> {{$t("observaciones")}}:</strong> {{cierre.observaciones}}
            </h4>
        </div>
    </div>
</template>
<script>
    import Datepicker from 'vuejs-datepicker';
    import {
        DatePicker,
        Select,
        Option,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Button,
        Checkbox,
        CheckboxGroup
    } from 'element-ui'
    import swal from 'sweetalert2'
    import moment from 'moment'

    export default {
        created() {
            this.getCloseCash();
        },

        components: {
            [DatePicker.name]: DatePicker,
            [Select.name]: Select,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Button.name]: Button,
            [Option.name]: Option,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        props: ['idBusiness', 'idDay'],
        data() {
            return {
                cierre: ""
            }
        },
        methods: {

            getCloseCash() {
                var config = {
                    params: {
                        idBusiness: this.idBusiness,
                        idDay: this.idDay,
                        jwt: this.$store.getters.jwt
                    },
                    headers: {'Authorization': "Bearer " + this.$store.getters.jwt}
                };

                let vm = this;
                this.$store.dispatch("setIdBusiness", this.idBusiness);
                this.axios.get(this.$store.getters.apiUrl + "sales/getCloseCash", config)
                    .then(function (response) {
                        if (response.data.response) {
                            vm.cierre = response.data.result;
                        }
                        else {

                            swal({
                                title: vm.$t('atencion'),
                                text: response.data.result,
                                confirmButtonClass: 'btn btn-info btn-fill',
                                type: 'error'
                            });

                        }
                        vm.loading = false;

                    })
                    .catch(function (error) {
                        console.log(error);
                    });
            },


        }


    }
</script>

<style scoped>


</style>




// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Ventas/Widgets/Cierre.vue